import { Link } from 'react-router-dom';

import { Company, CrewMember, Registration, User } from '@legacy-types';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { Portlet } from '@shared/ui/components/Portlet';
import { cn } from '@shared/utils/helpers';

import { ShowUserRegistrationAccessVouchers } from '@admin/users/views/ShowUser/ShowUserRegistrationAccessVouchers';
import { ShowUserRegistrationCertificates } from '@admin/users/views/ShowUser/ShowUserRegistrationCertificates';
import { ShowUserRegistrationDocuments } from '@admin/users/views/ShowUser/ShowUserRegistrationDocuments';
import { ShowUserRegistrationFrequentPassageRequests } from '@admin/users/views/ShowUser/ShowUserRegistrationFrequentPassageRequests';
import { ShowUserRegistrationMaterialRequests } from '@admin/users/views/ShowUser/ShowUserRegistrationMaterialRequests';
import { ShowUserRegistrationParkingStickers } from '@admin/users/views/ShowUser/ShowUserRegistrationParkingStickers';
import { ShowUserRegistrationTransportRequests } from '@admin/users/views/ShowUser/ShowUserRegistrationTransportRequests';
import { ShowUserRegistrationWristbands } from '@admin/users/views/ShowUser/ShowUserRegistrationWristbands';

type ShowUserRegistrationProps = {
  company: Company;
  crewMember: CrewMember;
};

export function ShowUserRegistration({ company, crewMember }: ShowUserRegistrationProps) {
  return (
    <section key={crewMember.registrationId} className="space-y-8">
      <Portlet innerClassName="flex items-center gap-8">
        <div className="flex-1">
          <p className="text-2xl font-medium text-gray-700">{crewMember.registration?.company?.name}</p>
          <div className="mt-1 flex items-center gap-1 text-gray-500">
            {/* @ts-expect-error */}
            {company.crewAdmin === 1 && <span data-tip="Crew Admin" className="la la-user" />}
            {/* @ts-expect-error */}
            {company.gatekeepingAdmin === 1 && <span data-tip="Gatekeeping Admin" className="la la-truck" />}
            {/* @ts-expect-error */}
            {company.materialAdmin === 1 && <span data-tip="Material Admin" className="la la-wrench" />}
            <span>{crewMember.occupation}</span>
          </div>
        </div>
        <Button asChild>
          <Link to={`/admin/registrations/${crewMember.registrationId}/edit`}>
            Edit Registration <Icon icon="external-link" />
          </Link>
        </Button>
      </Portlet>
      <ShowUserRegistrationAccessVouchers crewMember={crewMember} />
      <ShowUserRegistrationWristbands crewMember={crewMember} />
      <ShowUserRegistrationParkingStickers crewMember={crewMember} />
      {/*<ShowUserRegistrationTransportRequests crewMember={crewMember} />*/}
      <ShowUserRegistrationFrequentPassageRequests crewMember={crewMember} />
      {/*<ShowUserRegistrationMaterialRequests crewMember={crewMember} />*/}
      <ShowUserRegistrationCertificates crewMember={crewMember} />
      {/*<ShowUserRegistrationDocuments crewMember={crewMember} />*/}
    </section>
  );
}
